<div class="org-view-container p-8 bg-slate-50 min-h-full">

    <!-- Header -->
    <div class="flex items-start justify-between mb-6">
        <div>
            <button type="button" (click)="goBack()"
                class="text-xs text-slate-400 hover:text-slate-600 transition-colors inline-flex items-center gap-1 mb-1">
                <svg class="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
                {{ 'organizationView.back' | translate }}
            </button>
            <h1 class="text-2xl font-bold text-slate-900">{{ organization()?.name || ('organizationView.titleFallback' |
                translate) }}</h1>
            <p class="text-sm text-slate-500 mt-0.5">{{ 'organizationView.subtitle' | translate }}</p>
        </div>
        @if (organization()) {
        <button type="button" (click)="editOrganization()"
            class="bg-blue-600 text-white px-4 py-2 rounded-lg font-medium text-sm hover:bg-blue-700 transition inline-flex items-center gap-2">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
            {{ 'organizationView.edit' | translate }}
        </button>
        }
    </div>

    <!-- Loading -->
    @if (loading()) {
    <div class="flex justify-center items-center py-16">
        <div class="animate-spin rounded-full h-10 w-10 border-2 border-slate-200 border-t-blue-600"></div>
    </div>
    }

    <!-- Messages -->
    @if (errorMessage()) {
    <div class="mb-6">
        <jjames-alert type="error" [dismissible]="true" (dismissed)="errorMessage.set(null)">{{ errorMessage()
            }}</jjames-alert>
    </div>
    }
    @if (successMessage()) {
    <div class="mb-6">
        <jjames-alert type="success" [dismissible]="true" (dismissed)="successMessage.set(null)">{{ successMessage()
            }}</jjames-alert>
    </div>
    }

    @if (!loading() && organization()) {

    <!-- Metric cards -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div class="bg-white p-5 rounded-xl border border-slate-100 shadow-sm flex items-center justify-between">
            <div>
                <div class="text-2xl font-bold text-slate-900">{{ getParkerCount() }}</div>
                <div class="text-xs text-slate-500 mt-1">{{ 'organizationView.metrics.parkers' | translate }} · {{
                    countAdmins() }} {{ (countAdmins() === 1 ? 'organizationView.metrics.admin' :
                    'organizationView.metrics.admins') | translate }}</div>
            </div>
            <div class="bg-blue-50 text-blue-600 p-3 rounded-lg">
                <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
            </div>
        </div>
        <div class="bg-white p-5 rounded-xl border border-slate-100 shadow-sm flex items-center justify-between">
            <div>
                <div class="text-2xl font-bold text-slate-900">{{ getZoneCount() }}</div>
                <div class="text-xs text-slate-500 mt-1">{{ 'organizationView.metrics.zones' | translate }}</div>
            </div>
            <div class="bg-blue-50 text-blue-600 p-3 rounded-lg">
                <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                </svg>
            </div>
        </div>
        <div class="bg-white p-5 rounded-xl border border-slate-100 shadow-sm flex items-center justify-between">
            <div>
                <div class="text-2xl font-bold text-slate-900">{{ getSpaceCount() }}</div>
                <div class="text-xs text-slate-500 mt-1">{{ 'organizationView.metrics.spaces' | translate }}</div>
            </div>
            <div class="bg-blue-50 text-blue-600 p-3 rounded-lg">
                <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5" />
                </svg>
            </div>
        </div>
        <div class="bg-white p-5 rounded-xl border border-slate-100 shadow-sm flex items-center justify-between">
            <div>
                <div class="text-2xl font-bold text-slate-900">{{ getPoolConfigCount() }}</div>
                <div class="text-xs text-slate-500 mt-1">{{ 'organizationView.metrics.poolConfigs' | translate }}</div>
            </div>
            <div class="bg-blue-50 text-blue-600 p-3 rounded-lg">
                <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
            </div>
        </div>
    </div>

    <!-- Tabs -->
    <div class="flex space-x-6 border-b border-slate-200 mb-6">
        <button type="button" (click)="setTab('profile')"
            [class]="activeTab() === 'profile' ? 'border-b-2 border-blue-600 text-blue-600' : 'border-b-2 border-transparent text-slate-500 hover:text-slate-700'"
            class="pb-3 font-medium text-sm transition">
            {{ 'organizationView.tabs.profile' | translate }}
        </button>
        <button type="button" (click)="setTab('transactions')"
            [class]="activeTab() === 'transactions' ? 'border-b-2 border-blue-600 text-blue-600' : 'border-b-2 border-transparent text-slate-500 hover:text-slate-700'"
            class="pb-3 font-medium text-sm transition">
            {{ 'organizationView.tabs.transactions' | translate }}
        </button>
        <button type="button" (click)="setTab('parkers')"
            [class]="activeTab() === 'parkers' ? 'border-b-2 border-blue-600 text-blue-600' : 'border-b-2 border-transparent text-slate-500 hover:text-slate-700'"
            class="pb-3 font-medium text-sm transition">
            {{ 'organizationView.tabs.parkers' | translate }}
            <span class="ml-2 px-2 py-0.5 text-xs bg-slate-100 text-slate-600 rounded-full">{{ getParkerCount()
                }}</span>
        </button>
        <button type="button" (click)="setTab('inventory')"
            [class]="activeTab() === 'inventory' ? 'border-b-2 border-blue-600 text-blue-600' : 'border-b-2 border-transparent text-slate-500 hover:text-slate-700'"
            class="pb-3 font-medium text-sm transition">
            {{ 'organizationView.tabs.inventory' | translate }}
            <span class="ml-2 px-2 py-0.5 text-xs bg-slate-100 text-slate-600 rounded-full">{{ getPoolConfigCount()
                }}</span>
        </button>
        <button type="button" (click)="setTab('easypasses')"
            [class]="activeTab() === 'easypasses' ? 'border-b-2 border-blue-600 text-blue-600' : 'border-b-2 border-transparent text-slate-500 hover:text-slate-700'"
            class="pb-3 font-medium text-sm transition">
            {{ 'organizationView.tabs.easypasses' | translate }}
            @if (easypassesLoaded()) {
            <span class="ml-2 px-2 py-0.5 text-xs bg-slate-100 text-slate-600 rounded-full">{{ easypassesTotalCount()
                }}</span>
            }
        </button>
        <button type="button" (click)="setTab('easypassTransactions')"
            [class]="activeTab() === 'easypassTransactions' ? 'border-b-2 border-blue-600 text-blue-600' : 'border-b-2 border-transparent text-slate-500 hover:text-slate-700'"
            class="pb-3 font-medium text-sm transition">
            {{ 'organizationView.tabs.easypassTransactions' | translate }}
            @if (ezTxLoaded()) {
            <span class="ml-2 px-2 py-0.5 text-xs bg-slate-100 text-slate-600 rounded-full">{{ ezTxTotalCount()
                }}</span>
            }
        </button>
    </div>

    <!-- ============================ WORKSPACE 1: PROFILE & BILLING ============================ -->
    @if (activeTab() === 'profile') {
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">

        <!-- Organization Information -->
        <div class="bg-white p-6 rounded-xl border border-slate-100 shadow-sm">
            <h2 class="text-base font-semibold text-slate-900 mb-4">{{ 'organizationView.profile.orgInfo' | translate }}
            </h2>
            <dl class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
                <div>
                    <dt class="text-xs font-semibold text-slate-500 uppercase">{{ 'organizationView.profile.name' |
                        translate }}</dt>
                    <dd class="mt-1 text-sm text-slate-900">{{ organization()?.name }}</dd>
                </div>
                <div>
                    <dt class="text-xs font-semibold text-slate-500 uppercase">{{ 'organizationView.profile.orgId' |
                        translate }}</dt>
                    <dd class="mt-1 font-mono text-[11px] text-slate-400 break-all">{{ organization()?.id }}</dd>
                </div>
                <div class="sm:col-span-2">
                    <dt class="text-xs font-semibold text-slate-500 uppercase">{{ 'organizationView.profile.description'
                        | translate }}</dt>
                    <dd class="mt-1 text-sm text-slate-900">{{ organization()?.description || '—' }}</dd>
                </div>
                <div>
                    <dt class="text-xs font-semibold text-slate-500 uppercase">{{ 'organizationView.profile.created' |
                        translate }}</dt>
                    <dd class="mt-1 text-sm text-slate-900">{{ organization()?.createdAt | date:'medium' }}</dd>
                </div>
                <div>
                    <dt class="text-xs font-semibold text-slate-500 uppercase">{{ 'organizationView.profile.lastUpdated'
                        | translate }}</dt>
                    <dd class="mt-1 text-sm text-slate-900">{{ organization()?.updatedAt | date:'medium' }}</dd>
                </div>
            </dl>
        </div>

        <!-- Billing Address -->
        <div class="bg-white p-6 rounded-xl border border-slate-100 shadow-sm">
            <h2 class="text-base font-semibold text-slate-900 mb-4">{{ 'organizationView.profile.billingAddress' |
                translate }}</h2>
            @if (hasBillingAddress) {
            <dl class="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-4">
                <div>
                    <dt class="text-xs font-semibold text-slate-500 uppercase">{{
                        'organizationView.profile.addressLine1' | translate }}</dt>
                    <dd class="mt-1 text-sm text-slate-900">{{ organization()?.billingAddress?.firstAddressLine || '—'
                        }}</dd>
                </div>
                <div>
                    <dt class="text-xs font-semibold text-slate-500 uppercase">{{
                        'organizationView.profile.addressLine2' | translate }}</dt>
                    <dd class="mt-1 text-sm text-slate-900">{{ organization()?.billingAddress?.secondAddressLine || '—'
                        }}</dd>
                </div>
                <div>
                    <dt class="text-xs font-semibold text-slate-500 uppercase">{{ 'organizationView.profile.city' |
                        translate }}</dt>
                    <dd class="mt-1 text-sm text-slate-900">{{ organization()?.billingAddress?.locality || '—' }}</dd>
                </div>
                <div>
                    <dt class="text-xs font-semibold text-slate-500 uppercase">{{ 'organizationView.profile.postCode' |
                        translate }}</dt>
                    <dd class="mt-1 text-sm text-slate-900">{{ organization()?.billingAddress?.postCode || '—' }}</dd>
                </div>
                <div>
                    <dt class="text-xs font-semibold text-slate-500 uppercase">{{ 'organizationView.profile.region' |
                        translate }}</dt>
                    <dd class="mt-1 text-sm text-slate-900">{{ organization()?.billingAddress?.region || '—' }}</dd>
                </div>
                <div>
                    <dt class="text-xs font-semibold text-slate-500 uppercase">{{ 'organizationView.profile.country' |
                        translate }}</dt>
                    <dd class="mt-1 text-sm text-slate-900">{{ countryLabel(organization()?.billingAddress?.countryCode)
                        }}</dd>
                </div>
            </dl>
            } @else {
            <p class="text-sm text-slate-400 italic">{{ 'organizationView.profile.noAddress' | translate }}</p>
            }
        </div>
    </div>
    }

    <!-- ============================ WORKSPACE 2: PARKERS & ACCESS ============================ -->
    <!-- ============================ WORKSPACE 2: TRANSACTIONS ============================ -->
    @if (activeTab() === 'transactions') {
    <div class="bg-white border border-slate-200 rounded-xl overflow-hidden">
        <div class="px-5 py-4 border-b border-slate-200 flex flex-wrap items-end gap-3">
            <div>
                <label class="block text-xs font-medium text-slate-500 mb-1">{{ 'organizationView.transactions.from' |
                    translate }}</label>
                <input type="date" [value]="txFrom()" (input)="txFrom.set($any($event.target).value)"
                    class="border border-slate-200 rounded-lg px-3 py-2 text-sm" />
            </div>
            <div>
                <label class="block text-xs font-medium text-slate-500 mb-1">{{ 'organizationView.transactions.to' |
                    translate }}</label>
                <input type="date" [value]="txTo()" (input)="txTo.set($any($event.target).value)"
                    class="border border-slate-200 rounded-lg px-3 py-2 text-sm" />
            </div>
            <jjames-button variant="primary" size="sm" (clicked)="applyTransactionFilter()">{{
                'organizationView.transactions.apply' | translate }}</jjames-button>
            <span class="ml-auto text-sm text-slate-500">{{ 'organizationView.transactions.stays' | translate: { count:
                txTotalCount() } }}</span>
        </div>

        @if (transactionsError()) {
        <div class="p-5">
            <jjames-alert>{{ transactionsError() }}</jjames-alert>
        </div>
        }

        @if (txTimelineEvents().length > 0) {
        <div class="px-5 py-4 border-b border-slate-200">
            <div class="flex items-baseline justify-between mb-3">
                <h3 class="text-sm font-semibold text-slate-900">{{ 'organizationView.transactions.occupancy' |
                    translate }}</h3>
                <span class="text-xs text-slate-500">{{ 'organizationView.transactions.capacity' | translate: {
                    capacity: txCapacity() } }}</span>
            </div>
            <jjames-timeline-chart [events]="txTimelineEvents()" [capacity]="txCapacity()" [windowStart]="txFrom()"
                [windowEnd]="txTo()" />
            @if (txTimelineTruncated()) {
            <p class="text-xs text-amber-600 mt-2">{{ 'organizationView.transactions.truncated' | translate }}</p>
            }
        </div>
        }

        @if (transactionsLoading()) {
        <div class="p-10 text-center text-sm text-slate-500">{{ 'organizationView.transactions.loading' | translate }}
        </div>
        } @else if (getPoolConfigCount() === 0) {
        <!-- A stay is only linked to an organization through a pool, so no pools means nothing to show
             here at all - said plainly rather than as an empty table. -->
        <div class="p-10 text-center">
            <p class="text-sm text-slate-600 font-medium">{{ 'organizationView.transactions.noPoolsTitle' | translate }}
            </p>
            <p class="text-xs text-slate-500 mt-1">{{ 'organizationView.transactions.noPoolsHint' | translate }}</p>
        </div>
        } @else if (transactions().length === 0) {
        <div class="p-10 text-center">
            <p class="text-sm text-slate-600 font-medium">{{ 'organizationView.transactions.emptyTitle' | translate }}
            </p>
            <p class="text-xs text-slate-500 mt-1">{{ 'organizationView.transactions.emptyHint' | translate }}</p>
        </div>
        } @else {
        <div class="overflow-x-auto">
            <table class="min-w-full text-sm">
                <thead class="bg-slate-50 text-slate-500">
                    <tr>
                        <th class="text-left font-medium px-5 py-3">{{ 'organizationView.transactions.started' |
                            translate }}</th>
                        <th class="text-left font-medium px-5 py-3">{{ 'organizationView.transactions.ended' | translate
                            }}</th>
                        <th class="text-left font-medium px-5 py-3">{{ 'organizationView.transactions.plate' | translate
                            }}</th>
                        <th class="text-left font-medium px-5 py-3">{{ 'organizationView.transactions.pool' | translate
                            }}</th>
                        <th class="text-left font-medium px-5 py-3">{{ 'organizationView.transactions.spaceZone' |
                            translate }}</th>
                        <th class="text-left font-medium px-5 py-3">{{ 'organizationView.transactions.duration' |
                            translate }}</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-100">
                    @for (t of transactions(); track t.id) {
                    <tr class="hover:bg-slate-50">
                        <td class="px-5 py-3 text-slate-900">{{ t.startedAt ? (t.startedAt | date:'short') : '—' }}</td>
                        <td class="px-5 py-3 text-slate-600">{{ t.endedAt ? (t.endedAt | date:'short') :
                            ('organizationView.transactions.ongoing' | translate) }}
                        </td>
                        <td class="px-5 py-3 font-medium text-slate-900">{{ t.licensePlateDetails?.fullNumber || '—' }}
                        </td>
                        <td class="px-5 py-3 text-slate-600">{{ transactionPoolName(t) }}</td>
                        <td class="px-5 py-3 text-slate-600">{{ transactionLocation(t) }}</td>
                        <td class="px-5 py-3 text-slate-600">{{ t.duration || '—' }}</td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="px-5 py-3 border-t border-slate-200">
            <jjames-paginator [config]="transactionsPagination" (pageChange)="onTransactionsPageChange($event)" />
        </div>
        }
    </div>
    }

    @if (activeTab() === 'parkers') {
    <div class="space-y-4">

        <!-- Toolbar -->
        <div class="flex flex-wrap items-center justify-between gap-3">
            <div class="flex gap-2">
                <button type="button" (click)="setParkerRoleFilter('all')"
                    [class]="parkerRoleFilter() === 'all' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'"
                    class="px-3 py-1.5 rounded-full text-xs font-medium border transition-colors">{{
                    'organizationView.parkers.filterAll' | translate }}</button>
                <button type="button" (click)="setParkerRoleFilter('admins')"
                    [class]="parkerRoleFilter() === 'admins' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'"
                    class="px-3 py-1.5 rounded-full text-xs font-medium border transition-colors">{{
                    'organizationView.parkers.filterAdmins' | translate }}</button>
                <button type="button" (click)="setParkerRoleFilter('members')"
                    [class]="parkerRoleFilter() === 'members' ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'"
                    class="px-3 py-1.5 rounded-full text-xs font-medium border transition-colors">{{
                    'organizationView.parkers.filterMembers' | translate }}</button>
                <input type="search" [value]="membersSearch()"
                    (input)="onMembersSearchInput($any($event.target).value)"
                    [placeholder]="'organizationView.parkers.searchPlaceholder' | translate"
                    class="w-64 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-sm text-slate-900 outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition" />
            </div>
            <button type="button" (click)="showAddParkerForm.set(true)"
                class="bg-blue-600 text-white px-4 py-2 rounded-lg font-medium text-sm hover:bg-blue-700 transition inline-flex items-center gap-2">
                <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                </svg>
                {{ 'organizationView.parkers.addAccount' | translate }}
            </button>
        </div>

        <!-- Add parker form -->
        @if (showAddParkerForm()) {
        <div class="rounded-xl border border-slate-200 bg-white p-5 space-y-4">
            <!-- Mode switch -->
            <div class="flex gap-1 bg-slate-100 rounded-lg p-1 w-fit">
                <button type="button" (click)="addParkerMode.set('lp'); addParkerError.set(null)"
                    [class]="addParkerMode() === 'lp' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'"
                    class="px-3 py-1.5 rounded-md text-xs font-medium transition-colors">{{
                    'organizationView.parkers.byPlate' | translate }}</button>
                <button type="button" (click)="addParkerMode.set('email'); addParkerError.set(null)"
                    [class]="addParkerMode() === 'email' ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700'"
                    class="px-3 py-1.5 rounded-md text-xs font-medium transition-colors">{{
                    'organizationView.parkers.byEmail' | translate }}</button>
            </div>

            @if (addParkerError()) { <p class="text-sm text-red-600">{{ addParkerError() }}</p> }

            <!-- Identifier, role and action on one line: the whole form is three decisions. -->
            <div class="flex flex-wrap items-end gap-3">
                <div class="w-full sm:w-72">
                    @if (addParkerMode() === 'lp') {
                    <label class="block text-xs font-semibold text-slate-500 uppercase mb-1.5">{{
                        'organizationView.parkers.licensePlate' | translate }}</label>
                    <input type="text" [value]="addParkerLpInput()"
                        (input)="addParkerLpInput.set($any($event.target).value.toUpperCase())"
                        (keyup.enter)="addParkerByLp()"
                        [placeholder]="'organizationView.parkers.platePlaceholder' | translate" maxlength="15"
                        autocomplete="off" spellcheck="false"
                        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-mono tracking-wider text-slate-900 uppercase outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition" />
                    } @else {
                    <label class="block text-xs font-semibold text-slate-500 uppercase mb-1.5">{{
                        'organizationView.parkers.emailAddress' | translate }}</label>
                    <input type="email" [value]="addParkerEmailInput()"
                        (input)="addParkerEmailInput.set($any($event.target).value)"
                        (keyup.enter)="searchParkerByEmail()"
                        [placeholder]="'organizationView.parkers.emailPlaceholder' | translate"
                        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition" />
                    }
                </div>

                <div class="w-full sm:w-44">
                    <label class="block text-xs font-semibold text-slate-500 uppercase mb-1.5">{{
                        'organizationView.parkers.role' | translate }}</label>
                    <select [value]="addParkerRole()" (change)="addParkerRole.set($any($event.target).value)"
                        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition">
                        <option [value]="Role.Member">{{ 'organizationView.parkers.roleMember' | translate }}</option>
                        <option [value]="Role.Admin">{{ 'organizationView.parkers.roleAdmin' | translate }}</option>
                    </select>
                </div>

                @if (addParkerMode() === 'lp') {
                <jjames-button variant="primary" (clicked)="addParkerByLp()" [disabled]="addParkerLoading()">{{
                    addParkerLoading() ? ('organizationView.parkers.adding' | translate) :
                    ('organizationView.parkers.add' | translate) }}</jjames-button>
                } @else {
                <jjames-button variant="primary" (clicked)="searchParkerByEmail()" [disabled]="addParkerLoading()">{{
                    'organizationView.parkers.search' | translate }}</jjames-button>
                }
                <jjames-button variant="secondary" (clicked)="resetAddParkerForm()">{{
                    'organizationView.parkers.cancel' | translate }}</jjames-button>
            </div>

            <!-- Email search results -->
            @if (addParkerMode() === 'email' && addParkerEmailSearchDone()) {
            @if (addParkerEmailResults().length > 0) {
            <div class="space-y-2 sm:max-w-xl">
                @for (p of addParkerEmailResults(); track p.id) {
                <div
                    class="flex items-center justify-between gap-3 bg-slate-50 rounded-lg border border-slate-100 px-3 py-2">
                    <div class="min-w-0">
                        <p class="text-sm font-medium text-slate-900 truncate">{{ (p.firstName || p.lastName) ?
                            ((p.firstName ?? '') + ' ' + (p.lastName ?? '')).trim() : '—' }}</p>
                        <p class="text-xs text-slate-500 truncate">{{ p.email }}</p>
                    </div>
                    <jjames-button variant="primary" (clicked)="addParkerByEmailResult(p)"
                        [disabled]="addParkerLoading()">{{ 'organizationView.parkers.add' | translate }}</jjames-button>
                </div>
                }
            </div>
            } @else {
            <div class="space-y-3 sm:max-w-xl">
                <p class="text-sm text-slate-600">{{ 'organizationView.parkers.noParkerFound' | translate }}
                    <button type="button" (click)="showCreateParkerForm.set(true)"
                        class="text-blue-600 hover:underline font-medium">{{ 'organizationView.parkers.createNewParker'
                        | translate }}</button>
                </p>
                @if (showCreateParkerForm()) {
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-3 border-t border-slate-100">
                    <div>
                        <label class="block text-xs font-semibold text-slate-500 uppercase mb-1.5">{{
                            'organizationView.parkers.firstName' | translate }} <span
                                class="text-red-500">*</span></label>
                        <input type="text" [value]="createParkerFirstName()"
                            (input)="createParkerFirstName.set($any($event.target).value)"
                            [placeholder]="'organizationView.parkers.firstNamePlaceholder' | translate"
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition" />
                    </div>
                    <div>
                        <label class="block text-xs font-semibold text-slate-500 uppercase mb-1.5">{{
                            'organizationView.parkers.lastName' | translate }} <span
                                class="text-red-500">*</span></label>
                        <input type="text" [value]="createParkerLastName()"
                            (input)="createParkerLastName.set($any($event.target).value)"
                            [placeholder]="'organizationView.parkers.lastNamePlaceholder' | translate"
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition" />
                    </div>
                    <div>
                        <label class="block text-xs font-semibold text-slate-500 uppercase mb-1.5">{{
                            'organizationView.parkers.password' | translate }} <span
                                class="text-red-500">*</span></label>
                        <input type="password" [value]="createParkerPassword()"
                            (input)="createParkerPassword.set($any($event.target).value)"
                            [placeholder]="'organizationView.parkers.passwordPlaceholder' | translate"
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition" />
                    </div>
                    <div>
                        <label class="block text-xs font-semibold text-slate-500 uppercase mb-1.5">{{
                            'organizationView.parkers.licensePlate' | translate }} <span
                                class="text-slate-400 normal-case">{{ 'organizationView.parkers.optional' | translate
                                }}</span></label>
                        <input type="text" [value]="createParkerLp()"
                            (input)="createParkerLp.set($any($event.target).value.toUpperCase())"
                            [placeholder]="'organizationView.parkers.platePlaceholder' | translate"
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 font-mono tracking-wider uppercase outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition" />
                    </div>
                </div>
                <jjames-button variant="primary" (clicked)="createAndAddParker()" [disabled]="addParkerLoading()">{{
                    addParkerLoading() ? ('organizationView.parkers.creating' | translate) :
                    ('organizationView.parkers.createAndAdd' | translate) }}</jjames-button>
                }
            </div>
            }
            }
        </div>
        }

        <!-- Parkers data table -->
        <div class="overflow-x-auto bg-white rounded-xl border border-slate-100 shadow-sm">
            @if (parkersLoading()) {
            <div class="flex justify-center items-center py-12">
                <div class="animate-spin rounded-full h-8 w-8 border-2 border-slate-200 border-t-blue-600"></div>
            </div>
            } @else if (getEnrichedParkers().length > 0) {
            <table class="min-w-full">
                <thead class="bg-slate-50">
                    <tr>
                        <th class="text-left text-xs font-semibold text-slate-500 uppercase tracking-wider p-4">{{
                            'organizationView.parkers.memberCol' | translate }}
                        </th>
                        <th class="text-left text-xs font-semibold text-slate-500 uppercase tracking-wider p-4">{{
                            'organizationView.parkers.roleCol' | translate }}
                        </th>
                        <th class="text-left text-xs font-semibold text-slate-500 uppercase tracking-wider p-4">{{
                            'organizationView.parkers.platesCol' | translate }}</th>
                        <th class="text-left text-xs font-semibold text-slate-500 uppercase tracking-wider p-4">{{
                            'organizationView.parkers.addedCol' | translate }}
                        </th>
                        <th class="text-right text-xs font-semibold text-slate-500 uppercase tracking-wider p-4">{{
                            'organizationView.parkers.actionsCol' | translate }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    @for (parker of getEnrichedParkers(); track parker.parkerId) {
                    <tr class="border-b border-slate-100 hover:bg-slate-50/50 transition">
                        <!-- Member -->
                        <td class="p-4">
                            <div class="flex items-center gap-3">
                                <div
                                    class="w-10 h-10 shrink-0 rounded-full bg-slate-100 text-slate-700 flex items-center justify-center font-medium text-sm">
                                    {{ getParkerInitials(parker) }}
                                </div>
                                <div class="min-w-0">
                                    <p class="text-sm font-medium text-slate-900 truncate">
                                        {{ (parker.firstName || parker.lastName) ? ((parker.firstName ?? '') + ' ' +
                                        (parker.lastName ?? '')).trim() : (parker.parkerId ?? '—') }}
                                    </p>
                                    <p class="text-xs text-slate-500 truncate">{{ parker.email || '—' }}</p>
                                </div>
                            </div>
                        </td>
                        <!-- Role -->
                        <td class="p-4">
                            @if (parker.role === Role.Admin) {
                            <span class="bg-emerald-50 text-emerald-700 text-xs px-2.5 py-1 rounded-full font-medium">{{
                                'organizationView.parkers.admin' | translate }}</span>
                            } @else {
                            <span class="bg-slate-100 text-slate-600 text-xs px-2.5 py-1 rounded-full font-medium">{{
                                'organizationView.parkers.member' | translate }}</span>
                            }
                        </td>
                        <!-- License plates -->
                        <td class="p-4">
                            <div class="flex flex-wrap items-center gap-1.5">
                                @if (parker.activeLicenses && parker.activeLicenses.length > 0) {
                                @for (plate of parker.activeLicenses; track plate.id) {
                                <span
                                    class="bg-slate-900 text-white font-mono text-xs px-2 py-1 rounded tracking-wide shadow-sm">{{
                                    plate.fullNumber }}</span>
                                }
                                } @else {
                                <span class="text-xs text-slate-400 italic">{{ 'organizationView.parkers.noPlates' |
                                    translate }}</span>
                                }
                            </div>
                        </td>
                        <!-- Added -->
                        <td class="p-4 text-xs text-slate-500 whitespace-nowrap">{{ parker.createdAt | date:'mediumDate'
                            }}</td>
                        <!-- Actions -->
                        <td class="p-4 text-right">
                            @if (deleteParkerConfirmId() === parker.parkerId) {
                            <div class="inline-flex items-center gap-2">
                                <span class="text-xs text-red-600">{{ 'organizationView.parkers.removeConfirm' |
                                    translate }}</span>
                                <jjames-button variant="primary" (clicked)="removeParker(parker.parkerId!)">{{
                                    'organizationView.parkers.yes' | translate }}</jjames-button>
                                <jjames-button variant="secondary" (clicked)="cancelRemoveParker()">{{
                                    'organizationView.parkers.no' | translate }}</jjames-button>
                            </div>
                            } @else {
                            <div class="inline-flex items-center gap-3">
                                <button type="button" (click)="openManagePlatesDialog(parker)"
                                    class="text-slate-400 hover:text-blue-600 transition-colors"
                                    [title]="'organizationView.parkers.managePlates' | translate">
                                    <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1" />
                                    </svg>
                                </button>
                                <button type="button" (click)="openChangeRoleDialog(parker)"
                                    class="text-slate-400 hover:text-blue-600 transition-colors"
                                    [title]="'organizationView.parkers.changeRole' | translate">
                                    <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                    </svg>
                                </button>
                                <button type="button" (click)="confirmRemoveParker(parker.parkerId!)"
                                    [disabled]="isOnlyAdmin(parker.parkerId!)"
                                    [class]="isOnlyAdmin(parker.parkerId!) ? 'text-slate-300 cursor-not-allowed' : 'text-slate-400 hover:text-red-600'"
                                    class="transition-colors" [title]="'organizationView.parkers.remove' | translate">
                                    <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                    </svg>
                                </button>
                            </div>
                            }
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
            <div class="p-3 border-t border-slate-100">
                <jjames-paginator [config]="membersPagination" (pageChange)="onMembersPageChange($event)" />
            </div>
            } @else {
            <div class="text-center py-12">
                <p class="text-sm text-slate-400 italic">{{ 'organizationView.parkers.empty' | translate }}</p>
            </div>
            }
        </div>
    </div>
    }

    <!-- ====================== WORKSPACE 3: PARKING RULES & INVENTORY ====================== -->
    @if (activeTab() === 'inventory') {
    <div class="grid grid-cols-1 xl:grid-cols-3 gap-6">

        <!-- Inventory panel (zones + spaces) -->
        <div class="space-y-6">

            <!-- Zones -->
            <div class="bg-white p-5 rounded-xl border border-slate-100 shadow-sm">
                <div class="flex items-center justify-between mb-3">
                    <h2 class="text-sm font-semibold text-slate-900">{{ 'organizationView.inventory.assignedZones' |
                        translate }}</h2>
                    <button type="button" (click)="showAddZoneForm.set(true)"
                        class="text-xs font-medium text-blue-600 hover:text-blue-700">{{
                        'organizationView.inventory.add' | translate }}</button>
                </div>

                @if (showAddZoneForm()) {
                <div class="rounded-lg border border-slate-200 bg-slate-50 p-3 space-y-3 mb-3">
                    @if (addZoneError()) { <p class="text-xs text-red-600">{{ addZoneError() }}</p> }
                    @if ((organization()?.parkingSpaces ?? []).length === 0) {
                    <p class="text-xs text-amber-600">{{ 'organizationView.inventory.noSpacesToAddZone' | translate }}
                    </p>
                    } @else {
                    <div>
                        <label class="block text-xs font-semibold text-slate-500 uppercase mb-1.5">{{
                            'organizationView.inventory.parkingSpace' | translate }}</label>
                        <select (change)="onAddZoneSpaceChange($any($event.target).value)"
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition">
                            <option value="">{{ 'organizationView.inventory.chooseSpace' | translate }}</option>
                            @for (space of organization()!.parkingSpaces!; track space.parkingSpaceId) {
                            <option [value]="space.parkingSpaceId">{{ getSpaceName(space.parkingSpaceId!) }}</option>
                            }
                        </select>
                    </div>
                    @if (addZoneLoadingZones()) {
                    <p class="text-xs text-slate-500">{{ 'organizationView.inventory.loadingZones' | translate }}</p>
                    } @else if (addZoneSpaceId() && addZoneSpaceZones().length === 0) {
                    <p class="text-xs text-slate-400 italic">{{ 'organizationView.inventory.noZonesForSpace' | translate
                        }}</p>
                    } @else if (addZoneSpaceZones().length > 0) {
                    <div class="space-y-1.5">
                        @for (zone of addZoneSpaceZones(); track zone.id) {
                        @let alreadyAssigned = isZoneAlreadyAssigned(zone.id!);
                        <label
                            [class]="alreadyAssigned ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:bg-white'"
                            class="flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm">
                            <input type="checkbox" [checked]="isZoneSelected(zone.id!)" [disabled]="alreadyAssigned"
                                (change)="toggleZoneSelection(zone.id!)"
                                class="h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500" />
                            <span class="flex-1 font-medium text-slate-900">{{ zone.name }}</span>
                            @if (alreadyAssigned) { <span class="text-xs text-emerald-600 font-medium">{{
                                'organizationView.inventory.added' | translate }}</span> }
                        </label>
                        }
                    </div>
                    }
                    }
                    <div class="flex gap-2 pt-1">
                        <jjames-button variant="primary" (clicked)="addZonesToOrg()"
                            [disabled]="addZoneSubmitting() || addZoneSelectedIds().size === 0">
                            {{ addZoneSubmitting() ? ('organizationView.inventory.adding' | translate) :
                            ('organizationView.inventory.addZones' | translate: { count: addZoneSelectedIds().size }) }}
                        </jjames-button>
                        <jjames-button variant="secondary" (clicked)="cancelAddZone()">{{
                            'organizationView.inventory.cancel' | translate }}</jjames-button>
                    </div>
                </div>
                }

                @if (organization()?.parkingZones && organization()!.parkingZones!.length > 0) {
                @for (zone of organization()!.parkingZones!; track zone.parkingZoneId) {
                <div class="flex justify-between items-center p-3 bg-slate-50 rounded-lg border border-slate-100 mb-2">
                    <div class="min-w-0">
                        <p class="text-sm font-medium text-slate-900 truncate">
                            @if (zoneNamesLoading()) { <span class="text-slate-400 italic">{{
                                'organizationView.inventory.loading' | translate }}</span> } @else { {{
                            getZoneName(zone.parkingZoneId!) }} }
                        </p>
                        <p class="font-mono text-[10px] text-slate-400 mt-0.5 truncate">{{ zone.parkingZoneId }}</p>
                    </div>
                    @if (deleteZoneConfirmId() === zone.parkingZoneId) {
                    <div class="inline-flex items-center gap-1.5 shrink-0">
                        <span class="text-xs text-red-600">{{ 'organizationView.inventory.removeConfirm' | translate
                            }}</span>
                        <jjames-button variant="primary" (clicked)="removeZone(zone.parkingZoneId!)">{{
                            'organizationView.inventory.yes' | translate }}</jjames-button>
                        <jjames-button variant="secondary" (clicked)="cancelRemoveZone()">{{
                            'organizationView.inventory.no' | translate }}</jjames-button>
                    </div>
                    } @else {
                    <button type="button" (click)="confirmRemoveZone(zone.parkingZoneId!)"
                        class="text-slate-400 hover:text-red-600 text-xs font-medium shrink-0">{{
                        'organizationView.inventory.remove' | translate }}</button>
                    }
                </div>
                }
                } @else {
                <p class="text-sm text-slate-400 italic">{{ 'organizationView.inventory.noZones' | translate }}</p>
                }
            </div>

            <!-- Spaces -->
            <div class="bg-white p-5 rounded-xl border border-slate-100 shadow-sm">
                <div class="flex items-center justify-between mb-3">
                    <h2 class="text-sm font-semibold text-slate-900">{{ 'organizationView.inventory.assignedSpaces' |
                        translate }}</h2>
                    <button type="button" (click)="openAddSpaceForm()"
                        class="text-xs font-medium text-blue-600 hover:text-blue-700">{{
                        'organizationView.inventory.add' | translate }}</button>
                </div>

                @if (showAddSpaceForm()) {
                <!-- Pick from the spaces this operator is granted, rather than searching the whole
                     estate by name: the list below is what the operator may actually manage. -->
                <div class="rounded-lg border border-slate-200 bg-slate-50 p-3 space-y-3 mb-3">
                    @if (addSpaceError()) { <p class="text-xs text-red-600">{{ addSpaceError() }}</p> }
                    @if (addSpaceSearchLoading()) {
                    <p class="text-xs text-slate-500">{{ 'organizationView.inventory.loading' | translate }}</p>
                    } @else if (accessibleSpaces().length > 0) {
                    <div>
                        <label class="block text-xs font-semibold text-slate-500 uppercase mb-1.5">{{
                            'organizationView.inventory.yourSpaces' | translate }}</label>
                        <input type="text" [value]="addSpaceSearchName()"
                            (input)="addSpaceSearchName.set($any($event.target).value)"
                            [placeholder]="'organizationView.inventory.filterByName' | translate"
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition" />
                    </div>
                    @if (getAddSpaceOptions().length > 0) {
                    <div class="space-y-1.5 max-h-64 overflow-y-auto">
                        @for (space of getAddSpaceOptions(); track space.id) {
                        <div
                            class="flex items-center justify-between rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm">
                            <div class="min-w-0">
                                <span class="font-medium text-slate-900 block truncate">{{ space.name }}</span>
                                <span class="font-mono text-[10px] text-slate-400 truncate block">{{ space.id }}</span>
                            </div>
                            <jjames-button variant="primary" (clicked)="addParkingSpace(space.id!)"
                                [disabled]="spacesLoading()">{{ 'organizationView.parkers.add' | translate
                                }}</jjames-button>
                        </div>
                        }
                    </div>
                    } @else {
                    <p class="text-xs text-slate-400 italic">
                        @if (addSpaceSearchName()) { {{ 'organizationView.inventory.noMatch' | translate }} }
                        @else { {{ 'organizationView.inventory.allAssigned' | translate }} }
                    </p>
                    }
                    }
                    <jjames-button variant="secondary" (clicked)="cancelAddSpace()">{{
                        'organizationView.inventory.close' | translate }}</jjames-button>
                </div>
                }

                @if (organization()?.parkingSpaces && organization()!.parkingSpaces!.length > 0) {
                @for (space of organization()!.parkingSpaces!; track space.parkingSpaceId) {
                <div class="flex justify-between items-center p-3 bg-slate-50 rounded-lg border border-slate-100 mb-2">
                    <div class="min-w-0">
                        <p class="text-sm font-medium text-slate-900 truncate">
                            @if (spaceNamesLoading()) { <span class="text-slate-400 italic">{{
                                'organizationView.inventory.loading' | translate }}</span> } @else { {{
                            getSpaceName(space.parkingSpaceId!) }} }
                        </p>
                        <p class="font-mono text-[10px] text-slate-400 mt-0.5 truncate">{{ space.parkingSpaceId }}</p>
                    </div>
                    @if (deleteSpaceConfirmId() === space.parkingSpaceId) {
                    <div class="inline-flex items-center gap-1.5 shrink-0">
                        <span class="text-xs text-red-600">{{ 'organizationView.inventory.removeConfirm' | translate
                            }}</span>
                        <jjames-button variant="primary" (clicked)="removeParkingSpace(space.parkingSpaceId!)">{{
                            'organizationView.inventory.yes' | translate }}</jjames-button>
                        <jjames-button variant="secondary" (clicked)="cancelRemoveSpace()">{{
                            'organizationView.inventory.no' | translate }}</jjames-button>
                    </div>
                    } @else {
                    <button type="button" (click)="confirmRemoveSpace(space.parkingSpaceId!)"
                        class="text-slate-400 hover:text-red-600 text-xs font-medium shrink-0">{{
                        'organizationView.inventory.remove' | translate }}</button>
                    }
                </div>
                }
                } @else {
                <p class="text-sm text-slate-400 italic">{{ 'organizationView.inventory.noSpaces' | translate }}</p>
                }
            </div>

            <!-- Cost Centers -->
            <div class="bg-white p-5 rounded-xl border border-slate-100 shadow-sm">
                <div class="flex items-center justify-between mb-3">
                    <h2 class="text-sm font-semibold text-slate-900">{{ 'organizationView.inventory.costCenters' |
                        translate }}</h2>
                    <button type="button" (click)="openAddCostCenterForm()"
                        class="text-xs font-medium text-blue-600 hover:text-blue-700">{{
                        'organizationView.inventory.add' | translate }}</button>
                </div>

                @if (showAddCostCenterForm()) {
                <div class="rounded-lg border border-slate-200 bg-slate-50 p-3 space-y-3 mb-3">
                    @if (addCostCenterError()) { <p class="text-xs text-red-600">{{ addCostCenterError() }}</p> }
                    <div>
                        <label class="block text-xs font-semibold text-slate-500 uppercase mb-1.5">{{
                            'organizationView.inventory.name' | translate }}</label>
                        <input type="text" [value]="newCostCenterName()"
                            (input)="newCostCenterName.set($any($event.target).value)"
                            [placeholder]="'organizationView.inventory.costCenterPlaceholder' | translate"
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition" />
                    </div>
                    <div>
                        <label class="block text-xs font-semibold text-slate-500 uppercase mb-1.5">{{
                            'organizationView.inventory.descriptionOptional' | translate }}</label>
                        <input type="text" [value]="newCostCenterDescription()"
                            (input)="newCostCenterDescription.set($any($event.target).value)"
                            class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-blue-600 focus:ring-2 focus:ring-blue-100 transition" />
                    </div>
                    <div class="flex gap-2 pt-1">
                        <jjames-button variant="primary" (clicked)="addCostCenter()"
                            [disabled]="addCostCenterSubmitting()">
                            {{ addCostCenterSubmitting() ? ('organizationView.inventory.adding' | translate) :
                            ('organizationView.inventory.addCostCenter' | translate) }}
                        </jjames-button>
                        <jjames-button variant="secondary" (clicked)="cancelAddCostCenter()">{{
                            'organizationView.inventory.cancel' | translate }}</jjames-button>
                    </div>
                </div>
                }

                @if (costCentersLoading()) {
                <p class="text-sm text-slate-400 italic">{{ 'organizationView.inventory.loading' | translate }}</p>
                } @else if (costCenters().length > 0) {
                @for (costCenter of costCenters(); track costCenter.id) {
                <div class="flex justify-between items-center p-3 bg-slate-50 rounded-lg border border-slate-100 mb-2">
                    <div class="min-w-0">
                        <p class="text-sm font-medium text-slate-900 truncate">{{ costCenter.name }}</p>
                        @if (costCenter.description) {
                        <p class="text-xs text-slate-400 mt-0.5 truncate">{{ costCenter.description }}</p>
                        }
                    </div>
                    @if (deleteCostCenterConfirmId() === costCenter.id) {
                    <div class="inline-flex items-center gap-1.5 shrink-0">
                        <span class="text-xs text-red-600">{{ 'organizationView.inventory.removeConfirm' | translate
                            }}</span>
                        <jjames-button variant="primary" (clicked)="deleteCostCenter(costCenter.id!)">{{
                            'organizationView.inventory.yes' | translate }}</jjames-button>
                        <jjames-button variant="secondary" (clicked)="cancelDeleteCostCenter()">{{
                            'organizationView.inventory.no' | translate }}</jjames-button>
                    </div>
                    } @else {
                    <button type="button" (click)="confirmDeleteCostCenter(costCenter.id!)"
                        class="text-slate-400 hover:text-red-600 text-xs font-medium shrink-0">{{
                        'organizationView.inventory.remove' | translate }}</button>
                    }
                </div>
                }
                } @else {
                <p class="text-sm text-slate-400 italic">{{ 'organizationView.inventory.noCostCenters' | translate }}
                </p>
                }
            </div>
        </div>

        <!-- Pool configuration panel (span 2) -->
        <div class="xl:col-span-2 bg-white p-6 rounded-xl border border-slate-100 shadow-sm">
            <div class="flex items-center justify-between mb-4">
                <div>
                    <h2 class="text-base font-semibold text-slate-900">{{ 'organizationView.inventory.poolConfigs' |
                        translate }}</h2>
                    <p class="text-sm text-slate-500 mt-0.5">{{ 'organizationView.inventory.poolConfigsHint' | translate
                        }}</p>
                </div>
                <button type="button" (click)="addPoolConfig()"
                    class="bg-blue-600 text-white text-sm font-medium px-4 py-2 rounded-lg hover:bg-blue-700 transition inline-flex items-center gap-2">
                    <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                    </svg>
                    {{ 'organizationView.inventory.addPoolConfig' | translate }}
                </button>
            </div>

            @if (organization()?.poolParkConfigs && organization()!.poolParkConfigs!.length > 0) {
            <div class="space-y-3">
                @for (config of organization()!.poolParkConfigs; track config.id) {
                <div class="rounded-xl border border-slate-200 p-4 hover:border-slate-300 transition-colors">
                    <div class="flex items-start justify-between gap-4">
                        <div class="flex-1 min-w-0">
                            <div class="flex items-center gap-2 flex-wrap">
                                <h3 class="text-sm font-semibold text-slate-900">{{ config.name }}</h3>
                                @if (config.isActive) {
                                <span
                                    class="bg-emerald-50 text-emerald-700 text-xs px-2 py-0.5 rounded-full font-medium">{{
                                    'organizationView.inventory.active' | translate }}</span>
                                } @else {
                                <span
                                    class="bg-slate-100 text-slate-600 text-xs px-2 py-0.5 rounded-full font-medium">{{
                                    'organizationView.inventory.inactive' | translate }}</span>
                                }
                            </div>
                            @if (config.description) { <p class="mt-1 text-sm text-slate-500">{{ config.description }}
                            </p> }

                            <div class="mt-3 flex flex-wrap gap-2">
                                <span
                                    class="inline-flex items-center gap-1 rounded-lg bg-slate-50 border border-slate-100 px-2.5 py-1 text-xs text-slate-600">
                                    <span class="text-slate-400">{{ 'organizationView.inventory.valid' | translate
                                        }}</span>
                                    {{ config.validFrom | date:'MMM d, y' }} – {{ config.validTo ? (config.validTo |
                                    date:'MMM d, y') : '∞' }}
                                </span>
                                <span
                                    class="inline-flex items-center gap-1 rounded-lg bg-slate-50 border border-slate-100 px-2.5 py-1 text-xs text-slate-600">
                                    <span class="text-slate-400">{{ 'organizationView.inventory.maxCars' | translate
                                        }}</span> {{ config.maxCarsAllowed ?? '—' }}
                                </span>
                                <span
                                    class="inline-flex items-center gap-1 rounded-lg bg-slate-50 border border-slate-100 px-2.5 py-1 text-xs text-slate-600">
                                    <span class="text-slate-400">{{ 'organizationView.inventory.parkers' | translate
                                        }}</span> {{ config.parkers?.length ??
                                    config.parkerIds?.length ?? 0 }}
                                </span>
                                <span
                                    class="inline-flex items-center gap-1 rounded-lg bg-slate-50 border border-slate-100 px-2.5 py-1 text-xs text-slate-600">
                                    <span class="text-slate-400">{{ 'organizationView.inventory.zones' | translate
                                        }}</span> {{ config.allowedZoneIds?.length ?? 0 }}
                                </span>
                            </div>

                            @if (config.parkers && config.parkers.length > 0) {
                            <div class="mt-3 pt-3 border-t border-slate-100">
                                <p class="text-xs font-semibold text-slate-500 uppercase mb-2">{{
                                    'organizationView.inventory.parkerLicenses' | translate }}</p>
                                <div class="flex flex-wrap gap-1.5">
                                    @for (parker of config.parkers; track parker.id) {
                                    @if (parker.activeLicenses && parker.activeLicenses.length > 0) {
                                    @for (plate of parker.activeLicenses; track plate.id) {
                                    <span
                                        class="bg-slate-900 text-white font-mono text-xs px-2 py-1 rounded tracking-wide shadow-sm">{{
                                        plate.fullNumber }}</span>
                                    }
                                    }
                                    }
                                </div>
                            </div>
                            }
                        </div>

                        <div class="flex items-center gap-3 shrink-0">
                            @if (deleteConfirmId() === config.id) {
                            <span class="text-xs text-red-600">{{ 'organizationView.inventory.removeConfirm' | translate
                                }}</span>
                            <jjames-button variant="primary" (clicked)="deletePoolConfig(config.id!)">{{
                                'organizationView.inventory.yes' | translate }}</jjames-button>
                            <jjames-button variant="secondary" (clicked)="cancelDelete()">{{
                                'organizationView.inventory.no' | translate }}</jjames-button>
                            } @else {
                            <button type="button" (click)="editPoolConfig(config.id!)"
                                class="text-slate-400 hover:text-blue-600 transition-colors"
                                [title]="'organizationView.edit' | translate">
                                <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                            </button>
                            <button type="button" (click)="confirmDeletePoolConfig(config.id!)"
                                class="text-slate-400 hover:text-red-600 transition-colors"
                                [title]="'organizationView.inventory.remove' | translate">
                                <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                            </button>
                            }
                        </div>
                    </div>
                </div>
                }
            </div>
            } @else {
            <div class="text-center py-12 border border-dashed border-slate-200 rounded-xl">
                <div
                    class="mx-auto w-12 h-12 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center mb-3">
                    <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                    </svg>
                </div>
                <h3 class="text-sm font-medium text-slate-900">{{ 'organizationView.inventory.noPoolConfigs' | translate
                    }}</h3>
                <p class="mt-1 text-sm text-slate-400">{{ 'organizationView.inventory.noPoolConfigsHint' | translate }}
                </p>
                <div class="mt-4">
                    <button type="button" (click)="addPoolConfig()"
                        class="bg-blue-600 text-white text-sm font-medium px-4 py-2 rounded-lg hover:bg-blue-700 transition">{{
                        'organizationView.inventory.addPoolConfig' | translate }}</button>
                </div>
            </div>
            }
        </div>
    </div>
    }

    <!-- ============================ WORKSPACE: EASYPASS INVITATIONS ============================ -->
    @if (activeTab() === 'easypasses') {
    <div class="bg-white border border-slate-200 rounded-xl overflow-hidden">
        <div class="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
            <h2 class="text-sm font-semibold text-slate-900">{{ 'organizationView.easypasses.title' | translate }}</h2>
            <span class="text-sm text-slate-500">{{ 'organizationView.easypasses.count' | translate: { count:
                easypassesTotalCount() } }}</span>
        </div>

        @if (easypassesError()) {
        <div class="p-5">
            <jjames-alert>{{ easypassesError() }}</jjames-alert>
        </div>
        }

        @if (easypassesLoading()) {
        <div class="p-10 text-center text-sm text-slate-500">{{ 'organizationView.easypasses.loading' | translate }}
        </div>
        } @else if (easypasses().length === 0) {
        <div class="p-10 text-center">
            <p class="text-sm text-slate-600 font-medium">{{ 'organizationView.easypasses.emptyTitle' | translate }}</p>
            <p class="text-xs text-slate-500 mt-1">{{ 'organizationView.easypasses.emptyHint' | translate }}</p>
        </div>
        } @else {
        <div class="overflow-x-auto">
            <table class="min-w-full text-sm">
                <thead class="bg-slate-50 text-slate-500">
                    <tr>
                        <th class="text-left font-medium px-5 py-3">{{ 'organizationView.easypasses.event' | translate
                            }}</th>
                        <th class="text-left font-medium px-5 py-3">{{ 'organizationView.easypasses.costCenter' |
                            translate }}</th>
                        <th class="text-left font-medium px-5 py-3">{{ 'organizationView.easypasses.valid' | translate
                            }}</th>
                        <th class="text-left font-medium px-5 py-3">{{ 'organizationView.easypasses.redeemed' |
                            translate }}</th>
                        <th class="text-left font-medium px-5 py-3">{{ 'organizationView.easypasses.status' | translate
                            }}</th>
                        <th class="text-right font-medium px-5 py-3">{{ 'organizationView.easypasses.actions' |
                            translate }}</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-100">
                    @for (pass of easypasses(); track pass.id) {
                    <tr class="hover:bg-slate-50">
                        <td class="px-5 py-3 font-medium text-slate-900">{{ pass.title ||
                            ('organizationView.easypasses.untitled' | translate) }}</td>
                        <td class="px-5 py-3 text-slate-600">{{ pass.costCenterName || '—' }}</td>
                        <td class="px-5 py-3 text-slate-600 whitespace-nowrap">
                            {{ pass.validFrom ? (pass.validFrom | date:'short') : '—' }} –
                            {{ pass.validTo ? (pass.validTo | date:'short') : ('organizationView.easypasses.noExpiry' |
                            translate) }}
                        </td>
                        <td class="px-5 py-3 text-slate-600">{{ easypassCapacityLabel(pass) }}</td>
                        <td class="px-5 py-3">
                            <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold"
                                [class]="easypassStatus(pass).classes">
                                {{ easypassStatus(pass).label }}
                            </span>
                        </td>
                        <td class="px-5 py-3 text-right">
                            <div class="inline-flex items-center gap-1">
                                <a [href]="easypassRedeemUrl(pass)" target="_blank" rel="noopener"
                                    [matTooltip]="'organizationView.easypasses.redeemTooltip' | translate"
                                    class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-indigo-500 hover:bg-indigo-50 hover:text-indigo-700 transition-colors">
                                    <mat-icon class="!w-5 !h-5 !text-[18px] leading-5">open_in_new</mat-icon>
                                </a>
                                @if (revokeEasypassConfirmId() === pass.id) {
                                <span class="text-xs text-red-600">{{ 'organizationView.easypasses.revokeConfirm' |
                                    translate }}</span>
                                <jjames-button variant="primary" (clicked)="revokeEasypass(pass.id!)">{{
                                    'organizationView.easypasses.yes' | translate }}</jjames-button>
                                <jjames-button variant="secondary" (clicked)="cancelRevokeEasypass()">{{
                                    'organizationView.easypasses.no' | translate }}</jjames-button>
                                } @else {
                                <button type="button" (click)="confirmRevokeEasypass(pass.id!)"
                                    [matTooltip]="'organizationView.easypasses.revoke' | translate"
                                    class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-red-500 hover:bg-red-50 hover:text-red-700 transition-colors">
                                    <mat-icon class="!w-5 !h-5 !text-[18px] leading-5">delete_outline</mat-icon>
                                </button>
                                }
                            </div>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="px-5 py-3 border-t border-slate-200">
            <jjames-paginator [config]="easypassesPagination" (pageChange)="onEasypassesPageChange($event)" />
        </div>
        }
    </div>
    }


    <!-- ==================== WORKSPACE 6: EASYPASS TRANSACTIONS ==================== -->
    @if (activeTab() === 'easypassTransactions') {
    <div class="bg-white border border-slate-200 rounded-xl overflow-hidden">
        <div class="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
            <h2 class="text-sm font-semibold text-slate-900">{{ 'organizationView.easypassTransactions.title' |
                translate }}</h2>
            <span class="text-sm text-slate-500">{{ 'organizationView.easypassTransactions.count' | translate: { count:
                ezTxTotalCount() } }}</span>
        </div>

        @if (ezTxError()) {
        <div class="p-5">
            <jjames-alert>{{ ezTxError() }}</jjames-alert>
        </div>
        }

        @if (ezTxLoading()) {
        <div class="p-10 text-center text-sm text-slate-500">{{ 'organizationView.easypassTransactions.loading' |
            translate }}</div>
        } @else if (ezTxRows().length === 0) {
        <div class="p-10 text-center">
            <p class="text-sm text-slate-600 font-medium">{{ 'organizationView.easypassTransactions.emptyTitle' |
                translate }}</p>
        </div>
        } @else {
        <div class="overflow-x-auto">
            <table class="min-w-full text-sm">
                <thead class="bg-slate-50 text-slate-500">
                    <tr>
                        <th class="text-left font-medium px-5 py-3">{{ 'organizationView.easypassTransactions.plate' |
                            translate }}</th>
                        <th class="text-left font-medium px-5 py-3">{{ 'organizationView.easypassTransactions.from' |
                            translate }}</th>
                        <th class="text-left font-medium px-5 py-3">{{ 'organizationView.easypassTransactions.to' |
                            translate }}</th>
                        <th class="text-left font-medium px-5 py-3">{{
                            'organizationView.easypassTransactions.invitation' | translate }}</th>
                        <th class="text-left font-medium px-5 py-3">{{ 'organizationView.easypassTransactions.valid' |
                            translate }}</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-slate-100">
                    @for (row of ezTxRows(); track row.processId) {
                    <tr class="hover:bg-slate-50">
                        <td class="px-5 py-3 font-mono tracking-wider text-slate-900">{{ row.licensePlate }}</td>
                        <td class="px-5 py-3 text-slate-600 whitespace-nowrap">{{ row.startedAt | date:'short' }}</td>
                        <td class="px-5 py-3 text-slate-600 whitespace-nowrap">
                            {{ row.endedAt ? (row.endedAt | date:'short') :
                            ('organizationView.easypassTransactions.ongoing' | translate) }}
                        </td>
                        <td class="px-5 py-3 font-medium text-slate-900">{{ row.invitationTitle ||
                            ('organizationView.easypassTransactions.untitled' | translate) }}</td>
                        <td class="px-5 py-3 text-slate-600 whitespace-nowrap">
                            {{ row.invitationValidFrom ? (row.invitationValidFrom | date:'short') : '—' }} –
                            {{ row.invitationValidTo ? (row.invitationValidTo | date:'short') :
                            ('organizationView.easypassTransactions.noExpiry' | translate) }}
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="px-5 py-3 border-t border-slate-200">
            <jjames-paginator [config]="easypassTransactionsPagination"
                (pageChange)="onEasypassTransactionsPageChange($event)" />
        </div>
        }
    </div>
    }

    }
</div>